export class PriceHistoryItem {
  createTime: Date = null;
  name: string = null;
  seatsCount: number = null;
  basePrice: number = null;
}
